import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

const App = lazy(() => import("./App").then((module) => ({ default: module.App })));
const PublicSite = lazy(() => import("./PublicSite").then((module) => ({ default: module.PublicSite })));
const PublicInfoPage = lazy(() => import("./PublicInfoPage").then((module) => ({ default: module.PublicInfoPage })));
const RegistrationPage = lazy(() => import("./RegistrationPage").then((module) => ({ default: module.RegistrationPage })));
const PaymentResultPage = lazy(() => import("./PaymentResultPage").then((module) => ({ default: module.PaymentResultPage })));

const hostname = window.location.hostname.toLowerCase();
const publicPreview = new URLSearchParams(window.location.search).get("site") === "public";
const isPublicWebsite = hostname === "www.souldanceamposta.com" || hostname === "souldanceamposta.com" || publicPreview;
const publicPage = ({ "/normes": "normes", "/privacitat": "privacitat", "/avis-legal": "avis-legal", "/cookies": "cookies" } as const)[window.location.pathname as "/normes" | "/privacitat" | "/avis-legal" | "/cookies"];
const isRegistrationPage = window.location.pathname === "/inscripcion";
const isPaymentResultPage = window.location.pathname === "/pago/correcto";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Suspense fallback={<div className="route-loading" aria-label="Carregant" />}>
      {isPaymentResultPage ? <PaymentResultPage /> : isRegistrationPage ? <RegistrationPage /> : isPublicWebsite ? (publicPage ? <PublicInfoPage page={publicPage} /> : <PublicSite />) : <App />}
    </Suspense>
  </StrictMode>,
);
